export default "/institutions/cora.svg";